export { default } from './ArrowLink'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ArrowLink/index.js